import { message } from 'antd'

const getSelectedText = () => window.getSelection()?.toString().trim() ?? ''

const copyText = async (text: string) => {
  if (!text) {
    message.warning('No text to copy.')
    return
  }

  try {
    await navigator.clipboard.writeText(text)
    message.success('Copied to clipboard.')
  } catch {
    message.error('Unable to copy. Please copy the text manually.')
  }
}

export const getUpdateGridContextMenuItems = (params: any) => {
  const selectedText = getSelectedText()
  const cellText =
    params.value === null || params.value === undefined
      ? ''
      : String(params.value)
  const defaultItems =
    params.defaultItems?.filter(
      (item: string) =>
        !['copy', 'copyWithHeaders', 'copyWithGroupHeaders'].includes(item)
    ) ?? []

  return [
    {
      name: 'Copy',
      shortcut: 'Ctrl+C',
      action: () => {
        void copyText(selectedText || cellText)
      },
    },
    ...defaultItems,
  ]
}
